import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';
import useWindowSize from '@hooks/useWindowSize';
import { WIDTH_SM } from '@utils/constants';
import { getImgixSrc } from '@utils/images';

const THE_INFORMATION_HEADER = getImgixSrc({
  path: 'landing_pages/asia_tech_coverages/hero.png',
  isEnvDependent: false,
});

const Header = () => {
  const { width } = useWindowSize();
  const isMobile = width <= WIDTH_SM;
  return (
    <div className="mb-0 flex items-center justify-center gap-8 sm:gap-16 md:gap-72">
      <div>
        <h1 className="m-0 font-suisse-works text-headline-xs text-black sm:text-headline-lg md:text-headline-lg">
          The Information
        </h1>
        <div className="max-w-[650px] font-suisse-neue text-subheadline-sm">
          <p className="mb-0 mt-8">
            A global publication committed to original reporting and in-depth analysis of tech,
            finance and media industries.
          </p>
          {!isMobile && (
            <p className="mb-0 mt-20">
              Our dedicated Asia bureau delivers in-depth analysis of key Asian business
              developments, focusing on the evolving US-Asia competition amid new laws and
              regulations.
            </p>
          )}
        </div>
      </div>
      <div className="hidden sm:block">
        <LazyImgixImage
          alt="The Information Header"
          className="hidden sm:block sm:max-w-[290px] md:max-w-[307px]"
          src={THE_INFORMATION_HEADER}
          sizes="(min-width: 1200px) 600px, (min-width: 992px) 400px, 300px"
          wrapperClassName="sm:min-w-[290px] sm:min-h-[170px] md:min-w-[307px] md:min-h-[180px]"
        />
      </div>
    </div>
  );
};

export default Header;
